import { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useIsMobile } from '@hooks/use-is-mobile';

import { CompanySettingsNavigation } from 'components/navigation/company-settings';
import { CreateJobNavigation } from 'components/navigation/create-job';
import { MainNavigation } from 'components/navigation/main';
import { ProfileNavigation } from 'components/navigation/profile';

import { CompanySettingsRouteConfig } from './company-settings';
import { JobsRouteConfig, PreviewJobRouteConfig } from './jobs';
import { MainRouteConfig } from './main';
import { ProfileRouteConfig } from './profile';

export const RouteConfig = () => {
  return (
    <Routes>
      <Route path="*" element={<MainRoutes />} />
      <Route path="job/:jobId/preview/*" element={<PreviewJobRouteConfig />} />
      <Route path="job/*" element={<CreateJobRoutes />} />
      <Route path="settings/*" element={<CompanySettingsRoutes />} />
      <Route path="profile/*" element={<ProfileRoutes />} />
    </Routes>
  );
};

const MainRoutes = () => {
  const isMobile = useIsMobile();
  return (
    <Fragment>
      {!isMobile && <MainNavigation />}
      <MainRouteConfig />
    </Fragment>
  );
};

const CreateJobRoutes = () => {
  const isMobile = useIsMobile();
  return (
    <Fragment>
      {!isMobile && <CreateJobNavigation />}
      <JobsRouteConfig />
    </Fragment>
  );
};

const CompanySettingsRoutes = () => {
  const isMobile = useIsMobile();
  return (
    <Fragment>
      {!isMobile && <CompanySettingsNavigation />}
      <CompanySettingsRouteConfig />
    </Fragment>
  );
};

const ProfileRoutes = () => {
  const isMobile = useIsMobile();
  return (
    <Fragment>
      {!isMobile && <ProfileNavigation />}
      <ProfileRouteConfig />
    </Fragment>
  );
};
